<template>
  <!-- 促销 / 包邮 信息 -->
  <div class="promotions-box">
    <!-- 秒杀不参与跨店满减 -->
    <template v-if="!isFlashSale">
      <div 
        v-for="(item, idx) in promotionInfo.bigPromotion"
        :key="idx" 
        class="big-promotion promotion-item"
        @click=handleBigPromotionClick(item)
      >
        {{ item.title }} <van-icon name="arrow" />
      </div>
    </template>

     <div
      v-if="promotionInfo.freeShippingPromotion?.name"
      class="ship-promotion promotion-item"
      @click="handleFreeShippingPromotionClick(promotionInfo.freeShippingPromotion)"
    >
      {{ promotionInfo.freeShippingPromotion.name }} <van-icon name="arrow" />
    </div>

    <FreeShippingRulePopup v-model:visible="visible" :free-shipping-promotion="currentFreeShippingPromotion" />
  </div>
</template>
  
<script setup lang="ts">
import FreeShippingRulePopup from './FreeShippingRulePopup.vue'

defineProps<{ promotionInfo: ProductV2.IPromotion, isFlashSale: boolean}>()

const router = useRouter()
const visible = ref<boolean>(false)
const currentFreeShippingPromotion = ref<ProductV2.IFreeShippingPromotion>()

const handleBigPromotionClick = (item: ProductV2.IBigPromotion) => {
  const { id, rule } = item
  const { priceBreak, discount } = rule
  router.push({
    path: `/promotion-listings/${`${priceBreak}-${discount}`}-${item.name}-${id}`,
    query: { first_page: 'productDetail' }
  })
}

const handleFreeShippingPromotionClick = (item: ProductV2.IFreeShippingPromotion ) => {
  currentFreeShippingPromotion.value = item
  visible.value = true
}
</script>

<style lang="scss" scoped>
.promotion-item{
  display: inline-block;
  padding: 2px 12px 2px 20px;
  margin: 10px 10px 0 0;
  cursor: pointer;
  color: var(--pc-default-color);
  background-color: rgba($color: #DD3131, $alpha: 0.08);
  border-radius: 6px;
  font-size: 24px;
}
</style>
